import React from "react";
import { Widget, WidgetProps } from "@rjsf/utils";

export const SubtitleWidget: Widget = ({ label }: WidgetProps) => {
  return <h3 className="form-subtitle">{label}</h3>;
};
